import React, { useState } from 'react';

import { ProviderLocation } from '../profile/profile.types';
import { STEP_ONE_DEFAULT_VALUES } from './components/step-one/constants';
import { StepOneFormData } from './components/step-one/schema';
import { STEP_TWO_DEFAULT_VALUES } from './components/step-two/constants';
import { StepTwoFormData } from './components/step-two/schema';
import { ConfirmationData } from './booking.types';
import { BookingContext, BookingContextProps } from './booking-context';

type BookingProviderProps = {
  value?: BookingContextProps;
  fields?: unknown; // todo: add type
  children: React.ReactNode;
};

export const BookingProvider = ({ children, fields }: BookingProviderProps): JSX.Element => {
  // todo: remove these
  const [location, setLocationState] = useState<ProviderLocation>();

  const [stepOneData, setStepOneData] = useState<StepOneFormData>(STEP_ONE_DEFAULT_VALUES);
  const [stepTwoData, setStepTwoData] = useState<StepTwoFormData>(STEP_TWO_DEFAULT_VALUES);
  const [confirmationData, setConfirmationData] = useState<ConfirmationData | null>(null);

  const contextValues = {
    stepOneData,
    setStepOneData,
    stepTwoData,
    setStepTwoData,
    setLocation: setLocationState,
    location,
    fields,
    confirmationData,
    setConfirmationData,
  };

  return <BookingContext.Provider value={contextValues}>{children}</BookingContext.Provider>;
};

export default BookingProvider;
